module.exports = __webpack_public_path__ + "c4e85adc145c72e2ce21c1bdf2db214f.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/logo.svg
// module id = 636
// module chunks = 0